import axiosInstance from "../instance/AxiosInstance";

export const approvalNotificationService = {
  getApprovalNotifications: async (params) => {
    const { pageNo, pageSize, paginationRequired = true } = params;
    const response = await axiosInstance.get(
      `/adminNotification/list?pageNo=${pageNo}&pagesize=${pageSize}&pagination_required=${paginationRequired}`
    );

    return {
      data: response.data.data,
      totalCount: response.data.data.totalCount,
      unreadCount: response.data.unreadCount,
      currentPage: pageNo,
      totalRecords:response.data.totalRecords,
      totalPages: Math.ceil(response.data.totalPages)
    };
  },
  
  // markNotificationRead: async (id) => {
  //   const response = await axiosInstance.get(
  //     `/adminNotification/getadminNotification?admin_notification_id=${id}`
  //   );
    
  //   await axiosInstance.put(
  //     `/adminNotification/updateadminNotification/${id}`, 
  //     { ...response.data.data, "is_readed": 1,}
  //   );
    
  //   return response.data;
  // }
};